/* Review pagination uses native horizontal touch scrolling. */
(() => {
  if (window.zooReviewsInitialized) return;
  window.zooReviewsInitialized = true;
  const instances = new WeakMap();

  const AUTOPLAY_DELAY = 4000; // ms between slides

  function initialize(section) {
    if (instances.has(section)) return;
    const list = section.querySelector('.reviews-track');
    const pagination = section.querySelector('.review-pagination');
    const cards = Array.from(list.children);
    if (!cards.length) return;
    const mobile = window.matchMedia('(max-width: 767px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let page = 0;
    let pages = 1;
    let lastWidth = -1;
    let lastMobile = null;
    let frame = 0;

    // ── Autoplay ──────────────────────────────────────────────────────────────
    let autoplayTimer = null;
    let paused = false;

    function startAutoplay() {
       if (reducedMotion.matches || mobile.matches) return; // disabled on mobile
      stopAutoplay();
      autoplayTimer = setInterval(() => {
        if (!paused) go(page < pages - 1 ? page + 1 : 0);
      }, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function pause()  { paused = true;  }
    function resume() { paused = false; }
    // ─────────────────────────────────────────────────────────────────────────

    function target(index) {
      const card = cards[Math.min(index * (mobile.matches ? 1 : 2), cards.length - 1)];
      const x = card.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
      const centered = mobile.matches ? x - (list.clientWidth - card.offsetWidth) / 2 : x;
      return Math.max(0, Math.min(list.scrollWidth - list.clientWidth, centered));
    }

    function mark() {
      Array.from(pagination.children).forEach((dot, index) =>
        dot.setAttribute('aria-current', String(index === page)));
    }

    function go(index) {
      page = Math.max(0, Math.min(pages - 1, index));
      list.scrollTo({ left: target(page), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      mark();
    }

    function layout() {
      if (lastWidth === list.clientWidth && lastMobile === mobile.matches) return;
      lastWidth = list.clientWidth;
      lastMobile = mobile.matches;
      pages = Math.ceil(cards.length / (mobile.matches ? 1 : 2));
      page = Math.min(page, pages - 1);
      pagination.replaceChildren();
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'review-dot';
        dot.setAttribute('aria-label', 'Show review page ' + (i + 1));
        dot.addEventListener('click', () => { go(i); startAutoplay(); }); // reset timer on manual click
        pagination.append(dot);
      }
      list.scrollTo({ left: target(page), behavior: 'instant' });
      mark();
    }

    // Pause on hover / touch
    section.addEventListener('mouseenter', pause);
    section.addEventListener('mouseleave', resume);
    section.addEventListener('focusin',    pause);
    section.addEventListener('focusout',   resume);
    section.addEventListener('touchstart', pause, { passive: true });
    section.addEventListener('touchend',   () => {
      // short delay so scroll-snap settles before resuming
      setTimeout(resume, 1200);
    }, { passive: true });

    list.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        let closest = Infinity;
        for (let i = 0; i < pages; i++) {
          const distance = Math.abs(list.scrollLeft - target(i));
          if (distance < closest) { closest = distance; page = i; }
        }
        mark();
      });
    }, { passive: true });

    list.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? pages - 1 : page + (event.key === 'ArrowRight' ? 1 : -1));
      startAutoplay(); // reset timer on keyboard navigation
    });

    const observer = new ResizeObserver(layout);
    observer.observe(list);

    instances.set(section, () => {
      stopAutoplay();
      observer.disconnect();
      cancelAnimationFrame(frame);
      instances.delete(section);
    });

    layout();
    startAutoplay(); // ← kick off autoplay after first layout
  }

  function mount(container) { container.querySelectorAll('.customer-reviews').forEach(initialize); }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load',   event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.customer-reviews').forEach(section => instances.get(section)?.());
  });
})();